export default __webpack_public_path__ + "static/images/blackpink_01_thumb.png";